document.addEventListener('page:loaded', function () {

  const outputCalculator = () => {
    let length = parseFloat(document.getElementById('length').value);
    let width = parseFloat(document.getElementById('width').value);
    let height = parseFloat(document.getElementById('height').value);
    if(!length || !width || !height){
      return;
    }
    length = isNaN(length) ? 1 : length;
    width = isNaN(width) ? 1 : width;
    height = isNaN(height) ? 1 : height;
    const output = (length * width * height) / 14;
    const result = output.toFixed(1);
    const outputElement = document.getElementById('output');
    outputElement.innerHTML = `${result} kW`
    updateCollectionLink(result);
  }

  const updateCollectionLink = (result) => {
    const button = document.getElementById('collection');
    const output = document.getElementById('output');
    let collection = "VIEW 3-5kW STOVES";
    let handle = '3-5kw';
    if (result > 5) {
      collection = 'VIEW 6-8kW STOVES';
      handle = '6-8kw';
    }
    if (result > 8) {
      collection = 'VIEW 9-12kW STOVES';
      handle = '9-12kw';
    }
    if (result > 12) {
      collection = 'VIEW 12kW+ STOVES';
      handle = '12-kw';
    }
    button.innerHTML = collection;
    button.href = `/collections/${handle}`;
    button.classList.add('btn-pulse');
    output.classList.add('text-pulse');
    const scrollElement = document.querySelector('.output-calculator');
    if (window.innerWidth < 768 && scrollElement.getBoundingClientRect().top < 0) {
      scrollElement.scrollIntoView({behavior:"smooth"});
    }
  };

  document.getElementById('calculate').addEventListener('click', (e) => {
    document.getElementById('collection').classList.remove('btn-pulse');
    document.getElementById('output').classList.remove('text-pulse');
    outputCalculator();
  });

  document.getElementById('reset').addEventListener('click', () => {
    const button = document.getElementById('collection');
    const output = document.getElementById('output');
    button.classList.remove('btn-pulse');
    output.classList.remove('text-pulse');
    output.innerText = '';
    document.getElementById('length').value = '';
    document.getElementById('width').value = '';
    document.getElementById('height').value = '';
  });

});